export default "__VITE_ASSET__C2Kzf9yP__"